<template>
  <!--  VISTA LISTAR-->
  <template v-if="view==='listar'">
    <HeaderComponent :title="title" :hiddenDefaultButton="true" :isCreateHidden="true"></HeaderComponent>
    <div class="mt-6">
      <DateRangePickerComponent @dateRangePicker="(newDateRangePicker)=>
        {this.dateRangePicker = newDateRangePicker}"></DateRangePickerComponent>
    </div>
    <div class="mt-6 grid grid-cols-6 gap-6">
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="id_rubro" class="block text-sm font-medium text-gray-700">Calcular por rubro</label>
        <select id="id_rubro" :value="loadDataOptions.id_rubro"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                @change="(newRubroId)=>{loadDataOptions.id_rubro=customUpdateValueData('id_rubro',newRubroId.target.value)}">
          <option value="" selected>Seleccione un rubro...</option>
          <option v-for="(rubro, index) of collectionRubros" :key="'B'+index" :value="rubro.id">{{
               `${rubro.rubro} - ${rubro.nombre}`
            }}
          </option>
        </select>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="fuente_macro" class="block text-sm font-medium text-gray-700">Calcular por fuente macro</label>
        <select id="fuente_macro" :value="loadDataOptions.id_fuente_macro"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                @change="(newFuenteMacroId)=>{loadDataOptions.id_fuente_macro=customUpdateValueData('id_fuente_macro', newFuenteMacroId.target.value);}">
          <option value="" selected>Seleccione una fuente macro...</option>
          <option v-for="(fuenteMacro, index) of collectionFuentesMacro" :key="'B'+index"
                  :value="fuenteMacro.id">{{
              `${fuenteMacro.nombre}`
            }}
          </option>
        </select>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="fuente_concreta" class="block text-sm font-medium text-gray-700">Calcular por fuente concreta</label>
        <select id="fuente_concreta" :value="loadDataOptions.id_fuente_concreta"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                @change="(newFuenteConcretaId)=>{loadDataOptions.id_fuente_concreta=customUpdateValueData('id_fuente_concreta', newFuenteConcretaId.target.value);}">
          <option value="" selected>Seleccione una fuente concreta...</option>
          <option v-for="(fuenteConcreta, index) of collectionFuentesConcretas" :key="'B'+index"
                  :value="fuenteConcreta.id">{{
              `${fuenteConcreta.codigo} - ${fuenteConcreta.nombre}`
            }}
          </option>
        </select>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="beneficiario_id" class="block text-sm font-medium text-gray-700">Calcular por beneficiario
          especifico</label>
        <select id="beneficiario_id" :value="loadDataOptions.id_beneficiario"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                @change="(newBeneficiarioId)=>{loadDataOptions.id_beneficiario=customUpdateValueData('id_beneficiario', newBeneficiarioId.target.value);}">
          <option value="" selected>Seleccione un beneficiario...</option>
          <option v-for="(beneficiario, index) of collectionBeneficiarios" :key="'B'+index" :value="beneficiario.id">{{
              beneficiario.nombre
            }}
          </option>
        </select>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="macro_ejecutor" class="block text-sm font-medium text-gray-700">Calcular por macro ejecutor</label>
        <select id="macro_ejecutor" :value="loadDataOptions.id_macro_ejecutor"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                @change="(newMacroEjecutorId)=>{loadDataOptions.id_macro_ejecutor=customUpdateValueData('id_macro_ejecutor', newMacroEjecutorId.target.value);}">
          <option value="" selected>Seleccione un macro ejecutor...</option>
          <option v-for="(macroEjecutor, index) of collectionMacroEjecutores" :key="'B'+index"
                  :value="macroEjecutor.id">{{
              `${macroEjecutor.nombre}`
            }}
          </option>
        </select>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="secretaria_ejecutora_id" class="block text-sm font-medium text-gray-700">Calcular por secretaría
          ejecutora especifica</label>
        <select id="secretaria_ejecutora_id" :value="loadDataOptions.id_secretaria_ejecutora"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                @change="(newSecretariaEjecutoraId)=>{loadDataOptions.id_secretaria_ejecutora=customUpdateValueData('id_secretaria_ejecutora', newSecretariaEjecutoraId.target.value);}">
          <option value="" selected>Seleccione una secretaría ejecutora...</option>
          <option v-for="(secretariaEjecutora, index) of collectionSecretariasEjecutoras" :key="'B'+index"
                  :value="secretariaEjecutora.id">{{
              secretariaEjecutora.nombre
            }}
          </option>
        </select>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="rp" class="block text-sm font-medium text-gray-700">Calcular por RP (Registro presupuestal)</label>
        <select id="rp" :value="loadDataOptions.rp"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                @change="(newRp)=>{loadDataOptions.rp=customUpdateValueData('rp', newRp.target.value);}">
          <option value="" selected>Seleccione un RP...</option>
          <option v-for="(rp, index) of collectionRps" :key="'B'+index"
                  :value="rp.rp">{{
              rp.rp
            }}
          </option>
        </select>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="cap_adicionado" class="block text-sm font-medium text-gray-700">Calcular por reincorporado</label>
        <select id="cap_adicionado"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                @change="(newReincorporado)=>{loadDataOptions.isReincorporado = customUpdateValueData('isReincorporado',newReincorporado.target.value);}">
          <option :value="false">No</option>      
          <option :value="true">Si</option>
        </select>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="cap_adicionado" class="block text-sm font-medium text-gray-700">Calcular por liberado</label>
        <select id="cap_adicionado"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                @change="(newLiberado)=>{loadDataOptions.isLiberado = customUpdateValueData('isLiberado',newLiberado.target.value);}">
          <option :value="false">No</option>
          <option :value="true">Si</option>
        </select>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="liberado_value" class="block text-sm font-medium text-gray-700">Valor de liberado</label>
        <ValueRangePicker id="liberado_value" :custom-number-format="separateNumberByCommaInput" @valueRangePicker="(newValueRangePicker) => {loadDataOptions.liberadoStart = newValueRangePicker.startValue; loadDataOptions.liberadoEnd = newValueRangePicker.endValue}"></ValueRangePicker>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="reincorporado_value" class="block text-sm font-medium text-gray-700">Valor de reincorporado</label>
        <ValueRangePicker id="reincorporado_value" :custom-number-format="separateNumberByCommaInput" @valueRangePicker="(newValueRangePicker) => {loadDataOptions.reincorporadoStart = newValueRangePicker.startValue; loadDataOptions.reincorporadoEnd = newValueRangePicker.endValue}"></ValueRangePicker>
      </div>
    </div>
    <button @click="calcular()"
            class="mt-6 text-white bg-green-500 w-full p-2 w-full hover:bg-green-600 focus:outline-none">
      <span class="me-3">Calcular saldo a depurar</span>
    </button>
    <hr>
    <div v-if="result['secretarias']">
      <div v-if="Object.keys(result['secretarias']).length" class="mt-6 overflow-x-auto">
        <div class="flex justify-between text-lg font-semibold text-left text-gray-900 mb-10">
          <div>Resultados</div>
          <button @click="descargarInforme()" class="px-4 py-2 text-white bg-blue-500 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-blue-600 focus:outline-none">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="inline-block w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/>
            </svg>
            <span class="ml-3">Descargar informe</span>
          </button>
        </div>
        <div class="flex flex-row text-sm font-semibold text-center border-b-2 border-blue-500 uppercase">
          <div class="w-1/6 grow-0 shrink-0 flex items-center justify-center">
            MACRO EJECUTOR
          </div>
          <div class="w-1/6 grow-0 shrink-0 flex items-center justify-center">
            FUENTE MACRO
          </div>
          <div class="w-1/6 grow-0 shrink-0 flex items-center justify-center">
            VALOR INICIAL
          </div>
          <div class="w-1/6 grow-0 shrink-0 flex items-center justify-center">
            LIBERADO
          </div>
          <div class="w-1/6 grow-0 shrink-0 flex items-center justify-center">
            REINCORPORADO
          </div>
          <div class="w-1/6 grow-0 shrink-0 flex items-center justify-center">
            SALDO
          </div>
        </div>
        <div class="flex flex-row text-center" v-for="(macroEjecutor, i) in Object.keys(result['secretarias'])" :key="i">
          <div class="w-1/6 grow-0 shrink-0 flex items-center justify-center py-10 bg-gray-100 hover:bg-gray-200 font-medium border-b-2 border-blue-500">
            {{ macroEjecutor }}
          </div>
          <div class="w-1/6 grow-0 shrink-0 flex flex-col">
            <template v-for="(fuenteMacro, j) in Object.keys(result['secretarias'][macroEjecutor]['fuentes'])" :key="j">
              <div class="py-10 bg-gray-100 hover:bg-gray-200 font-medium grow flex items-center justify-center border-b-2 border-blue-500">
                {{ fuenteMacro }}
              </div>
            </template>
            <div class="py-10 bg-gray-400 hover:bg-gray-500 grow flex items-center justify-center">
              TOTAL
            </div>
          </div>
          <div class="w-1/6 grow-0 shrink-0 flex flex-col">
            <template v-for="(fuenteMacro, j) in Object.keys(result['secretarias'][macroEjecutor]['fuentes'])" :key="j">
              <div class="py-10 bg-gray-100 hover:bg-gray-200 font-medium grow flex items-center justify-center">
                {{ separateNumberByComma(result['secretarias'][macroEjecutor]['fuentes'][fuenteMacro]['valorInicialFuenteMacro']) }}
              </div>
            </template>
            <div class="py-10 bg-gray-400 hover:bg-gray-500 grow flex items-center justify-center">
              {{ separateNumberByComma(result['secretarias'][macroEjecutor]['valorInicialMacroEjecutor']) }}
            </div>
          </div>
          <div class="w-1/6 grow-0 shrink-0 flex flex-col">
            <template v-for="(fuenteMacro, j) in Object.keys(result['secretarias'][macroEjecutor]['fuentes'])" :key="j">
              <div class="py-10 bg-gray-100 hover:bg-gray-200 font-medium grow flex items-center justify-center">
                {{ separateNumberByComma(result['secretarias'][macroEjecutor]['fuentes'][fuenteMacro]['totalLiberadoFuenteMacro']) }}
              </div>
            </template>
            <div class="py-10 bg-gray-400 hover:bg-gray-500 grow flex items-center justify-center">
              {{ separateNumberByComma(result['secretarias'][macroEjecutor]['totalLiberadoMacroEjecutor']) }}
            </div>
          </div>
          <div class="w-1/6 grow-0 shrink-0 flex flex-col">
            <template v-for="(fuenteMacro, j) in Object.keys(result['secretarias'][macroEjecutor]['fuentes'])" :key="j">
              <div class="py-10 bg-gray-100 hover:bg-gray-200 font-medium grow flex items-center justify-center">
                {{ separateNumberByComma(result['secretarias'][macroEjecutor]['fuentes'][fuenteMacro]['totalReincorporadoFuenteMacro']) }}
              </div>
            </template>
            <div class="py-10 bg-gray-400 hover:bg-gray-500 grow flex items-center justify-center">
              {{ separateNumberByComma(result['secretarias'][macroEjecutor]['totalReincorporadoMacroEjecutor']) }}
            </div>
          </div>
          <div class="w-1/6 grow-0 shrink-0 flex flex-col">
            <template v-for="(fuenteMacro, j) in Object.keys(result['secretarias'][macroEjecutor]['fuentes'])" :key="j">
              <div class="py-10 bg-gray-100 hover:bg-gray-200 font-medium grow flex items-center justify-center">
                {{ separateNumberByComma(result['secretarias'][macroEjecutor]['fuentes'][fuenteMacro]['saldoFuenteMacro']) }}
              </div>
            </template>
            <div class="py-10 bg-gray-400 hover:bg-gray-500 grow flex items-center justify-center">
              {{ separateNumberByComma(result['secretarias'][macroEjecutor]['saldoMacroEjecutor']) }}
            </div>
          </div>
        </div>
        <div class="flex flex-row text-center">
          <div class="w-1/6 grow-0 shrink-0">
            <div class="py-10 bg-gray-400 hover:bg-gray-500 grow flex items-center justify-center">
              GRAN TOTAL
            </div>
          </div>
          <div class="w-1/6 grow-0 shrink-0">
            <div class="py-10 bg-gray-400 hover:bg-gray-500 grow flex items-center justify-center">
              &nbsp;
            </div>
          </div>
          <div class="w-1/6 grow-0 shrink-0">
            <div class="py-10 bg-gray-400 hover:bg-gray-500 grow flex items-center justify-center">
              &nbsp;{{ separateNumberByComma(result['valorInicialGeneral'])}}
            </div>
          </div>
          <div class="w-1/6 grow-0 shrink-0">
            <div class="py-10 bg-gray-400 hover:bg-gray-500 grow flex items-center justify-center">
              &nbsp;{{ separateNumberByComma(result['totalLiberadoGeneral']) }}
            </div>
          </div>
          <div class="w-1/6 grow-0 shrink-0">
            <div class="py-10 bg-gray-400 hover:bg-gray-500 grow flex items-center justify-center">
              &nbsp;{{ separateNumberByComma(result['totalReincorporadoGeneral'])}}
            </div>
          </div>
          <div class="w-1/6 grow-0 shrink-0">
            <div class="py-10 bg-gray-400 hover:bg-gray-500 grow flex items-center justify-center">
              &nbsp;{{ separateNumberByComma(result['saldoGeneral'])}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <template v-else-if="view === 'ver_caps'">
    <VisualizacionCAPComponent :selected-data="{id: selectedPasivoExigibleId}" @updateValues="(res) => {view = res.view}" @updateDataCap="(cap) => {dataCap = cap.id}"/>
  </template>
  <template v-else-if="view === 'cargar_soportes_caps'">
    <CargueSoportesCAPComponent :selected-data="{id: selectedPasivoExigibleId}" @updateValues="(res) => {view = res.view}" :dataCap="dataCap" :entity=" { gender: 'm', value: 'Soporte CAP' }"/>
  </template>
</template>
<script>
import HeaderComponent from "@/layouts/main/HeaderComponent";
import DateRangePickerComponent from "@/layouts/DateRangePicker";
import {listCollectionData, updateValues} from "@/layouts/main";
import {useAuth} from "@/components/auth/store/composables";
import ValueRangePicker from "@/layouts/ValueRangePicker"
import { separateNumberByCommaInput } from "@/common/constants/functions";
import {
  copiaProfunda,
  generateTextError,
  separateNumberByComma,
  swal,
  useAPIRest,
  verifyHttpCode
} from "@/common/constants";
import {ref} from 'vue';
import { writeFile, utils } from "xlsx-js-style";
import VisualizacionCAPComponent from "./components/VisualizacionCAPComponent";
import CargueSoportesCAPComponent from "./components/CargueSoportesCAPComponent";
export default {
  name: 'GestionarCobroSaldo',
  components: {
    HeaderComponent,
    DateRangePickerComponent,
    ValueRangePicker,
    VisualizacionCAPComponent,
    CargueSoportesCAPComponent,
  },
  data: function () {
    return {
      view: 'listar',
      title: 'Calcular Pasivos Exigibles',
      Object: Object,
      updateValues,
      tableColumns: ['RP','FECHA','CODIGO RUBRO','NOMBRE RUBRO','FUENTE MACRO','CODIGO FUENTE','NOMBRE FUENTE', 
                    'NUMERO CONTRATO','OBJETO CONTRATO','NIT','BENEFICIARIO','SECRETARÍA EJECUTORA','VALOR PASIVO EXIGIBLE', 
                    'TOTAL LIBERADO', 'TOTAL REINCORPORADO','SALDO VIGENTE','OPCIONES'],
      separateNumberByComma,
      separateNumberByCommaInput
    }
  },
  async setup() {
    const authStored = useAuth();
    const authToken = ref(authStored.authToken);
    const collectionRubros = ref([]);
    const collectionFuentesMacro = ref([])
    const collectionFuentesConcretas = ref([]);
    const collectionBeneficiarios = ref([]);
    const collectionMacroEjecutores = ref([]);
    const collectionSecretariasEjecutoras = ref([]);
    const collectionRps = ref([]);
    const result = ref({});
    const selectedPasivoExigibleId = ref('');
    const dataCap = ref({});
    const selectedSaldo = ref({
      fuente_concreta: '',
      secretaria_ejecutora: '',
      year: ''
    });
    const descargarInforme = async () => {
      const contenidoExcel = [
        ['MACRO EJECUTOR', 'FUENTE MACRO', 'VALOR INICIAL', 'LIBERADO', 'REINCORPORADO', 'SALDO']
      ]

      let merges = []

      let fila = 0

      let celdasEstiloTotales = []

      for (const macroEjecutor in result.value['secretarias']) {
        let filaInicial = true
        let merge = { s: { r: undefined, c: 0}, e: { r: undefined, c: 0}}
        for (const fuenteMacro in result.value['secretarias'][macroEjecutor]['fuentes']) {
          fila++
          if (filaInicial) {
            contenidoExcel.push([macroEjecutor, fuenteMacro, result.value['secretarias'][macroEjecutor]['fuentes'][fuenteMacro]['valorInicialFuenteMacro'], result.value['secretarias'][macroEjecutor]['fuentes'][fuenteMacro]['totalLiberadoFuenteMacro'], result.value['secretarias'][macroEjecutor]['fuentes'][fuenteMacro]['totalReincorporadoFuenteMacro'], result.value['secretarias'][macroEjecutor]['fuentes'][fuenteMacro]['saldoFuenteMacro']])
            merge['s']['r'] = fila
            filaInicial = false
          }
          else {
            contenidoExcel.push(['', fuenteMacro, result.value['secretarias'][macroEjecutor]['fuentes'][fuenteMacro]['valorInicialFuenteMacro'], result.value['secretarias'][macroEjecutor]['fuentes'][fuenteMacro]['totalLiberadoFuenteMacro'], result.value['secretarias'][macroEjecutor]['fuentes'][fuenteMacro]['totalReincorporadoFuenteMacro'], result.value['secretarias'][macroEjecutor]['fuentes'][fuenteMacro]['saldoFuenteMacro']])
          }
        }
        contenidoExcel.push(['','TOTAL', result.value['secretarias'][macroEjecutor]['valorInicialMacroEjecutor'], result.value['secretarias'][macroEjecutor]['totalLiberadoMacroEjecutor'], result.value['secretarias'][macroEjecutor]['totalReincorporadoMacroEjecutor'], result.value['secretarias'][macroEjecutor]['saldoMacroEjecutor']])
        fila++
        celdasEstiloTotales.push(`B${fila + 1}`, `C${fila + 1}`, `D${fila + 1}`, `E${fila + 1}` ,`F${fila + 1}`)
        merge['e']['r'] = fila
        merges.push(merge)
      }

      contenidoExcel.push(['GRAN TOTAL', '', result.value['valorInicialGeneral'], result.value['totalLiberadoGeneral'], result.value['totalReincorporadoGeneral'], result.value['saldoGeneral']])
      celdasEstiloTotales.push(`B${fila + 2}`, `C${fila + 2}`, `D${fila + 2}`, `E${fila + 2}` ,`F${fila + 2}`)

      const workbook = utils.book_new();
      const worksheet = utils.aoa_to_sheet(contenidoExcel);
      Object.keys(worksheet).forEach((cell) => {
        if (cell.startsWith('A')) {
          worksheet[cell]['s'] = {
            alignment: {
                horizontal: 'center',
                vertical: 'center'
            },
            font: {
              bold: true
            }
          }
        }
      });
      ['A1', 'B1', 'C1', 'D1', 'E1', 'F1'].forEach(cell => {worksheet[cell]['s'] = {
        font: {
          bold: true,
          color: {
            rgb: 'FFFFFF'
          },
        },
        fill: {
          bgColor: {
            rgb: '000000'
          }
        }
      }})
      celdasEstiloTotales.forEach(cell => {worksheet[cell]['s'] = {
        font: {
          color: {
            rgb: 'FFFFFF'
          },
        },
        fill: {
          bgColor: {
            rgb: '000000'
          }
        }
      }})
      worksheet[`A${fila + 2}`]['s'] = {
        font: {
          color: {
            rgb: 'FFFFFF'
          },
        },
        fill: {
          bgColor: {
            rgb: '000000'
          }
        }
      }
      worksheet['!cols'] = [{wch: 75}, {wch: 25},  {wch: 17}, {wch: 17}, {wch: 17}, {wch: 17}]
      worksheet['!merges'] = merges
      utils.book_append_sheet(workbook, worksheet, 'informe');
      const fileName = 'informe_pasivos_exigibles.xlsx'
      writeFile(workbook, fileName, {
            type: 'binary',
            compression: true,
            bookType: 'xlsx',
        })
    };

    /**
     * @type {Object}
     * @description Objeto con las opciones para cargar los datos
     * @property {string} dateStart - Fecha de inicio para el cálculo
     * @property {string} dateEnd - Fecha de fin para el cálculo
     * @property {number} id_rubro - ID del rubro a filtrar
     * @property {number} fuente_concreta - fuente de financiación a filtrar
     * @property {number} id_beneficiario - ID del beneficiario a filtrar
     * @property {number} id_secretaria_ejecutora - ID de la secretaría ejecutora a filtrar
     * @property {boolean} isReincorporado - Indicador para filtrar si fue reincorporado
     * @property {boolean} isLiberado - Indicador para filtrar si fue liberado
     */
    const loadDataOptions = ref({
      dateStart: undefined,
      dateEnd: undefined,
      id_rubro: undefined,
      rp: undefined,
      id_fuente_macro: undefined,
      id_fuente_concreta: undefined,
      id_beneficiario: undefined,
      id_macro_ejecutor: undefined,
      id_secretaria_ejecutora: undefined,
      reincorporadoStart: 0,
      reincorporadoEnd: 99999999999999,
      liberadoStart: 0,
      liberadoEnd: 99999999999999,
      isReincorporado: undefined,
      isLiberado: undefined 
    });
    const dateRangePicker = ref(undefined);
    /**
     * @function customUpdateValueData
     * @description Función para validar y dar formato a los valores ingresados
     * @param {string} key - Nombre del campo a validar y dar formato
     * @param {*} value - Valor a validar y dar formato
     * @returns {*} Valor validado y formateado
     */
    const customUpdateValueData = (key, value) => {
      const listFieldNumeric = ['id_rubro', 'rp', 'id_beneficiario', 'id_secretaria_ejecutora', 'id_macro_ejecutor', 'id_fuente_concreta', 'id_fuente_macro'];
      if (listFieldNumeric.includes(key)) return value !== '' ? parseInt(value) : undefined;
      return value !== '' ? value : undefined;
    };
    /**
     * @function calcular
     * @async
     *
     * @description Esta función realiza el cálculo de los registros entre dos fechas
     * seleccionadas en un rango de fechas.
     *
     * @returns {Promise<void>}
     */
    const calcular = async () => {
      const newLoadDataOptions = copiaProfunda(loadDataOptions.value);
      const [dateStart, dateEnd] = dateRangePicker.value.getDates();
      if (!dateStart) await swal.fire('La fecha inicial es requerida', '', 'error');
      else if (!dateEnd) await swal.fire('La fecha final es requerida', '', 'error');
      else {
        newLoadDataOptions.dateStart = dateStart.toISOString().split('T')[0];
        newLoadDataOptions.dateEnd = dateEnd.toISOString().split('T')[0];
        loadDataOptions.value = newLoadDataOptions;
        await useAPIRest(process.env.VUE_APP_NEST_PASIVOEXIGIBLE_CALCULAR, 'GET', authToken.value, undefined, loadDataOptions.value).then(resJSON => {
          const {statusCode} = resJSON;
          delete resJSON.statusCode;
          const textError = generateTextError(resJSON);
          if (verifyHttpCode(statusCode, 'success')) {
            result.value = resJSON;
            swal.fire('Cálculo realizado con éxito', '', 'success');
          } else swal.fire(textError, '', 'error');
        })
      }
    };
    await listCollectionData(process.env.VUE_APP_NEST_RUBRO_FINDALL, {'collectionRubros': collectionRubros}, authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);
    await listCollectionData(process.env.VUE_APP_NEST_FUENTEMACRO_FINDALL, {'collectionFuentesMacro': collectionFuentesMacro}, authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);
    await listCollectionData(process.env.VUE_APP_NEST_FUENTECONCRETA_FINDALL, {'collectionFuentesConcretas': collectionFuentesConcretas}, authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);
    await listCollectionData(process.env.VUE_APP_NEST_BENEFICIARIO_FINDALL, {'collectionBeneficiarios': collectionBeneficiarios}, authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);
    await listCollectionData(process.env.VUE_APP_NEST_MACROEJECUTOR_FINDALL, {'collectionMacroEjecutores': collectionMacroEjecutores}, authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);
    await listCollectionData(process.env.VUE_APP_NEST_SECRETARIAEJECUTORA_FINDALL, {'collectionSecretariasEjecutoras': collectionSecretariasEjecutoras}, authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);
    await listCollectionData(process.env.VUE_APP_NEST_PASIVOEXIGIBLE_FINDALL, {'collectionRps': collectionRps}, authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false, {select: 'rp'});
    return {
      dateRangePicker,
      collectionRubros,
      collectionFuentesMacro,
      collectionFuentesConcretas,
      collectionBeneficiarios,
      collectionMacroEjecutores,
      collectionSecretariasEjecutoras,
      collectionRps,
      loadDataOptions,
      result,
      selectedSaldo,
      customUpdateValueData,
      calcular,
      descargarInforme,
      selectedPasivoExigibleId,
      dataCap,
    };
  }
}
</script>